import { z } from "zod";

import { monthlyAuditDate } from "@/schemas";

import {
  environmentalChecklistItem,
  environmentalChecklistItemWithTicket,
} from "../../../../schemas";

export const resEnvChecklistOtherSchema = z.object({
  auditDate: monthlyAuditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  otherEmergency: environmentalChecklistItem,
  otherCeilingFan: environmentalChecklistItemWithTicket,
  otherSanitizer: environmentalChecklistItem,
  otherBreaker: environmentalChecklistItem,
  otherShutoffs: environmentalChecklistItem,
  otherLight: environmentalChecklistItem,
  otherEscapePlan: environmentalChecklistItem,
  otherFireExtinguisher: environmentalChecklistItem,
  otherExitSign: environmentalChecklistItemWithTicket,
  otherFireAlarm: environmentalChecklistItemWithTicket,
  otherSleepRoom: environmentalChecklistItemWithTicket,
  otherSprinklerHead: environmentalChecklistItemWithTicket,
  otherBreakerPosition: environmentalChecklistItem,
});
